import { AUTHORITIES } from './authorities';
function isPermissionString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
function normalizePermissionKey(value) {
    if (!isPermissionString(value))
        return '';
    return value.trim().toLowerCase();
}
export function isWildcardPermission(permission) {
    if (!isPermissionString(permission))
        return false;
    return permission === '*' || normalizePermissionKey(permission) === '*';
}
export function isAdminPermission(permission) {
    const normalized = normalizePermissionKey(permission);
    return normalized === 'role_admin' || normalized === 'admin';
}
/**
 * Monolithic-style OR check: user passes if they hold **any** required permission.
 * `ROLE_ADMIN` and `*` always grant access (admin everywhere).
 */
export function hasAnyAuthority(userPermissions, requiredAny) {
    const validUser = userPermissions?.filter(isPermissionString) ?? [];
    const validRequired = requiredAny.filter(isPermissionString);
    if (!validUser.length) {
        return false;
    }
    if (validUser.some((p) => isWildcardPermission(p) || isAdminPermission(p))) {
        return true;
    }
    if (!validRequired.length) {
        return true;
    }
    const normalizedUser = new Set(validUser.map(normalizePermissionKey));
    return validRequired.some((required) => validUser.includes(required) ||
        normalizedUser.has(normalizePermissionKey(required)));
}
/** Route/menu helper: `[ADMIN, …specificPermissions]` (Monolithic pattern). */
export function pageAuthorities(...permissions) {
    return [AUTHORITIES.ADMIN, ...permissions].filter(isPermissionString);
}
